/* Native custom section; cleans up when Shopify removes or reloads it. */
(() => {
  if (window.cgauSplashBoot) { window.cgauSplashBoot(document); return; }
  const words = ['boring.', 'complicated.', 'intimidating.', 'confusing.', 'expensive.', 'ordinary.', 'a headache.', 'a guessing game.', 'hard work.', 'impersonal.', 'a chore.', 'out of reach.', 'rocket science.', 'a second job.', 'a drama.', 'doom & gloom.', 'Potato.'];
  const regularCount = words.length - 1;
  const mounted = new Map();
  function boot(root) {
    root.querySelectorAll('[data-cgau-splash]').forEach(panel => {
      if (mounted.has(panel)) return;
      const word = panel.querySelector('.cgau-splash__word');
      const reduced = matchMedia('(prefers-reduced-motion: reduce)');
      const abort = new AbortController();
      let index = 0, timer = null, visible = false, regularIndex = 0, sincePotato = 12;
      function render() {
        panel.dataset.look = String(index);
        word.textContent = words[index];
      }
      const active = () => visible && !document.hidden && !reduced.matches;
      const touch = matchMedia('(pointer: coarse)');
      const hold = () => touch.matches ? 2510 : 960; // Give mobile readers time; fewer background/type repaints.
      function schedule() { timer = setTimeout(change, hold()); }
      function change() {
        if (!active()) return;
        word.classList.add('is-changing');
        timer = setTimeout(() => {
          if (!active()) { word.classList.remove('is-changing'); return; }
          if (index !== regularCount && sincePotato >= regularCount && Math.random() < 0.06) {
            index = regularCount; sincePotato = 0;
          } else {
            regularIndex = (regularIndex + 1) % regularCount; index = regularIndex; sincePotato++;
          }
          render();
          word.classList.remove('is-changing');
          schedule();
        }, 90);
      }
      function sync() {
        clearTimeout(timer); timer = null;
        word.classList.remove('is-changing');
        const running = active();
        panel.dataset.running = String(running);
        if (reduced.matches) { index = 0; regularIndex = 0; render(); }
        if (running) schedule();
      }
      document.addEventListener('visibilitychange', sync, {signal:abort.signal});
      reduced.addEventListener('change', sync, {signal:abort.signal});
      const observer = new IntersectionObserver(entries => { visible = entries[0].isIntersecting; sync(); }, {threshold:0.05});
      observer.observe(panel);
      render(); sync();
      mounted.set(panel, () => { clearTimeout(timer); observer.disconnect(); abort.abort(); mounted.delete(panel); });
    });
  }
  window.cgauSplashBoot = boot;
  document.addEventListener('shopify:section:load', event => boot(event.target));
  document.addEventListener('shopify:section:unload', event => { mounted.forEach((cleanup, panel) => { if (event.target.contains(panel)) cleanup(); }); });
  boot(document);
})();
